import { render, staticRenderFns } from "./foodPrice.vue?vue&type=template&id=0ce2bacc&scoped=true&"
import script from "./foodPrice.vue?vue&type=script&lang=js&"
export * from "./foodPrice.vue?vue&type=script&lang=js&"
import style0 from "./foodPrice.vue?vue&type=style&index=0&id=0ce2bacc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2bacc",
  null
  
)

export default component.exports